import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = { class: "q-pa-md" }
const _hoisted_3 = { class: "q-gutter-x-md row justify-center" }

import { WithdrawalRequest } from '@/code/models';
import { centsToDollars } from '@/code/utils';

export default /*#__PURE__*/_defineComponent({
  __name: 'Withdrawal',
  props: {
    request: null
  },
  setup(__props: any) {

const props = __props as { request?: WithdrawalRequest }



return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    flat: "",
    bordered: "",
    class: "my-card"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(centsToDollars)((props.request?.Cash ?? 0) - 100)) + " Withdrawal Request", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator, { inset: "" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_btn, {
            label: "APPROVE",
            class: "bg-green",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('withdrawalClicked', true)))
          }),
          _createVNode(_component_q_btn, {
            label: "REJECT",
            class: "bg-red",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('withdrawalClicked', false)))
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})